export const IntercomEvent = {
  signedUp: "signed-up",
  verifiedEmail: "verified-email",
  seenTrialStartedModal: "seen-trial-started-modal",
  viewedProduct: "viewed-product",
  createdDraftProduct: "created-draft-product",
  publishedProduct: "published-product",
  connectedStore: "connected-store",
  boughtDigitalProduct: "bought-digital-product",
  placedManualOrder: "placed-manual-order",
  orderedSamples: "ordered-samples",
  madeSale: "made-sale",
  addedPaymentMethod: "added-payment-method",
  uploadedDesign: "uploaded-design",
  seenWelcomeModal: "seen-welcome-modal",
} as const
